import React, { useEffect, useState } from "react";
import BreadcrumbComponent from "../../../../CommonComponent/BreadcrumbComponent";
import { SkillAssessmentBreadcrumb } from "../../../../../../config/BreadcrumbConfig";
import { FormBox, InputBox } from "../../../../../../components/AntdAddons";
import { Button, Col, Flex, Form, Progress, Radio, Row, Tooltip } from "antd";
import { rules } from "./Rules";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  InfoCircleOutlined,
  VerticalLeftOutlined,
  VerticalRightOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../store/app";


/**
 * Renders common form component for skill portrait Exam.
 *
 * @param {object} props - The props object containing the following properties:
 *   - nextButton: A function to handle the next button click.
 *   - current: The current index of the question being displayed.
 *   - steps: An array of questions.
 *   - btnLoading: A boolean indicating if the button is in a loading state.
 *   - setCurrent: A function to set the current index.
 *   - isView: A boolean indicating if the form is in view mode.
 *   - lastArrayData: The last array data.
 *   - allMaster: An object containing master data.
 * @return {JSX.Element} The rendered form.
 */
const SkillAssessmentFrom = (props: any) => {

  const {
    nextButton,
    current,
    steps,
    btnLoading,
    setCurrent,
    isView,
    lastArrayData,
    allMaster,
    itemsPerPage
  } = props;

  const [options, setOption] = useState<any>();
  const initialStoreData: any = useSelector(
    (state: RootState) => state.AUTH.initialData
  );

  var isfirstChekboxes = false;



  useEffect(() => {
    const initialData: any = sessionStorage.getItem("initialData");
    const initialDataJson = JSON.parse(initialData);
    if (initialDataJson) {
      setOption(initialDataJson?.experience_levels);
    } else {
      setOption(initialStoreData?.experience_levels);
    }
  }, []);

  // Renders the appropriate answer input component based on the question type.
  const allInput: any = (data: any, indexAllQue: any) => {
    switch (data.options) {
      case 1:
        return (
          <InputBox.Select
            placeholder="Answer"
            name={data?.question_id}
            disabled={isView ?? false}
            required={!isView ? true : false}
            rules={isView ? [] : rules.answer()}
            options={{
              list: [
               { id: 1, name: "Yes" },
               { id: 2, name: "No" },
              ],
              valueKey: "id",
              textKey: "name",
            }}
          />
        );

      case 2:
        return (
          <InputBox.Select
            placeholder="Answer"
            name={data?.question_id}
            disabled={isView ?? false}
            required={!isView ? true : false}
            rules={isView ? [] : rules.answer()}
            allowClear
            showSearch
            filterOption={(input, option: any) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            options={{
              list: allMaster[data.master_type],
              valueKey: "id",
              textKey: "name",
            }}
          />
        );

      case 3:
        var classData = 'radioGrpExamIconHideTitle';
        if (!isfirstChekboxes) {
          classData = 'radioGrpExamIconShowTitle';
          isfirstChekboxes = true;
        }
        return (
          <Form.Item
            name={data?.question_id}
            rules={props.type !== "view" ? rules.answer() : []}
          >
            <Radio.Group disabled={isView ?? false}>
              <div
                className={`${classData
                  } radioGrpExamIcon radioGrpExamIconShowTitle `}
              >

                {options?.map((contentItem: any, index: number) => {
                  return (
                    <Radio value={contentItem.id} key={index}>
                      {contentItem?.name}
                    </Radio>
                  );
                })}


              </div>
            </Radio.Group>
          </Form.Item>
        );

      default:
        return (
          <Form.Item
            name={data?.question_id}
            rules={props.type !== "view" ? rules.answer() : []}
          >
            <Radio.Group>
              <div className="radioGrpExamIcon">
               {options?.map((contentItem: any, index: number) => {
                  return (
                    <Radio key={index} value={contentItem.id} >{contentItem?.title}</Radio>
                  );
                })}
              </div>
            </Radio.Group>
          </Form.Item>
        );
    }
  };

  const totalNumberOfSections = Math.ceil((steps?.length) / itemsPerPage);
  const currentSection = Math.ceil((totalNumberOfSections * (current + 1)) / (steps?.length))

  return (
    <div className="examModal">
      <section className='dashboard-sec'>
        <div className="container-fluid">
          <div className="breadcrumb has-button">
            <BreadcrumbComponent key={1} items={SkillAssessmentBreadcrumb.path} />
            {/* <Button className='common_Button green_border_common_btn'>Continue Your Career Journey</Button> */}
          </div>

          <div className="interesQnaSection skillSection">
            <div className='ansProgressSection'>
              <Row className='ansProgressRow'>
                <Col xs={24} sm={24} md={24} xl={12} lg={24}>
                  <h3 >Your progress </h3>
                </Col>
                <Col xs={24} sm={24} md={24} xl={12} lg={12}>
                  <h2 className="notranslate">{isView ? '100' : Math.round((current / steps.length) * 100)}% Completed</h2>
                </Col>
              </Row>
              <Flex gap="middle" align="center" >
                <Progress percent={isView ? 100 : Math.round((current / steps.length) * 100)} strokeColor="#0D5E0D" showInfo={false} />
              </Flex>

            </div>
            <div className="ansListRadiobtn">
              <div className='questions-section-title notranslate'>Section {currentSection} </div>
              <div className='questions-page-title notranslate'>Questions {current + 1} - {(current + itemsPerPage) > steps?.length ? steps.length : (current + itemsPerPage)}</div>
              <FormBox
                layout="vertical"
                autoComplete="off"
                form={props.form}
                id="skillForm"
                onFinish={nextButton}
                className="userProfile commanDrawer"
              >
                {props.getFirstSix.map((item: any, index: any) => {
                  return (
                    <div className="radioGrpExambox" key={index}>
                      <Row className="radioGrpExam">
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}  className="questions">
                          <div className="step_content">
                           {" "}
                            <span className="currentAns notranslate">Q.{item.index}</span>
                           {item?.description ? (
                              <>
                                <span className="currentQuestion">
                                 {item?.title}
                                </span>
                                <span className="infoCircle">
                                  <Tooltip
                                    placement="top"
                                    title={item?.description}
                                    key={index}
                                    overlayClassName="examTooltip"
                                  >
                                    <InfoCircleOutlined />
                                  </Tooltip>
                                </span>
                              </>
                            ) : (
                              <span className="currentQuestion">{item?.title}</span>
                            )}
                          </div>
                        </Col>


                        <Col xs={24} sm={24} md={24} lg={24} xl={16}  className="answers ">
                          {allInput(item, index)}
                        </Col>
                      </Row>
                    </div>
                  );
                })}
                <div className="logInBtn">
                 {current >= 1 && (
                    <Button
                      className="common_Button green_border_common_btn"
                      onClick={() => {
                        setCurrent(current - 6);
                      }}
                    >
                      Back
                    </Button>
                  )}

                 {steps?.length === lastArrayData?.index ? (
                    <Button
                      className="common_Button green_border_common_btn"
                      form={props.id}
                      loading={btnLoading}
                      htmlType="submit"
                    >
                      Finish
                    </Button>
                  ) : (
                    <Button
                      className="common_Button green_border_common_btn next-btn"
                      form={props.id}
                      loading={btnLoading}
                      htmlType="submit"
                    >
                      Next
                    </Button>
                  )}
                </div>
              </FormBox>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default SkillAssessmentFrom;
